// eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
export const getWaterfallGroupHeaderStyles = ({ waterFallGroupHeader = {} }, { palette = {} }) => ({
  header: {
    paddingLeft: '8px',
    paddingRight: '12px',
    paddingTop: '9px',
    paddingBottom: '11px',
    fontSize: '12px',
    color: palette.themePrimary,
  },
});
